import React from "react";
import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { getContactEmail } from "../../utils/brandingConfig";

import UserConstantsHelper from "../../helpers/constants/user";

const CardManualReviewRequiredModal = ({ show, handleClose }) => {
  const profile = useSelector((state) => state.users.profile);
  const supportEmail = getContactEmail();

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      className={`manual-review light`}
    >
      <Modal.Body className="mb-4">
        <Alert variant="danger text-center">
          <Button
            variant="primary"
            className={`btn-sm red react ${
              UserConstantsHelper.isDocumentPending(profile.data)
                ? "yellow"
                : "red"
            }`}
            type="button"
          >
            <i className="fas fa-2x fa-exclamation"></i>
          </Button>
          <p>
            We were unable to validate your card. Kindly send an email with the following attachments to {supportEmail} :
          </p>
          <div>
            <ul>
                <li>A government-issued ID.</li>
                <li>Images of the front and back of your card.</li>
                <li>A selfie of you holding your ID.</li>
            </ul>
          </div>
          <p>Please also include your username in the email.</p>
        </Alert>
        
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default CardManualReviewRequiredModal;
